import React, { useRef, useContext, useState, useLayoutEffect, memo, useCallback } from "react";

import { callApi, serializeObject, isEmpty } from "bodycodi/cmap/app/js/common";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import MemberSearchPop from "bodycodi/cmap/app/components/cmap3010/memberSearchPop";
import Condition from "bodycodi/cmap/app/components/cmap3010/condition";
import MemberList from "bodycodi/cmap/app/components/common/MemberList";
import { State } from "bodycodi/cmap/app/components/cmap3010/memberMngt";
import { Members } from "bodycodi/cmap/app/type";

type ChooseMemberPassPopWrapProp = {
  setMember: Function;
  chooseMemberList: any;
};

type ChooseMemberPassPopProp = {
  setMember: Function;
  chooseMemberList: any;
  handleClose: Function;
};

const ChooseMemberPassPopWrap = ({ setMember, chooseMemberList }: ChooseMemberPassPopWrapProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_MEMBER_PASS_COMUNITY_POP",
      open: { chooseMemberPassComunityPop: false },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_SEARCH_POP", open: { memberSearchPop: false } });
  }, []);

  return (
    <CustomDialog open={state.chooseMemberPassComunityPop} onClose={handleClose}>
      <PopupHeader title="회원선택" onClickBack={handleClose} />
      {state.chooseMemberPassComunityPop && (
        <ChooseMemberPassPop
          setMember={setMember}
          chooseMemberList={chooseMemberList}
          handleClose={handleClose}
        />
      )}
    </CustomDialog>
  );
};

const ChooseMemberPassPop = ({
  setMember,
  chooseMemberList,
  handleClose,
}: ChooseMemberPassPopProp) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const form = useRef<HTMLDivElement>(null);
  const [members, setMembers] = useState<Members>({
    appointmentMemberTotalCount: 0,
    chargeMemberTotalCount: 0,
    entranceMemberTotalCount: 0,
    memberList: [],
  });
  const [state, setState] = useState<State>({
    tabName: "APPOINTMENT",
    pageNo: 0,
    listSize: 10,
    loading: false,
    first: true,
    isDone: false,
    isScrollEnd: false,
    isBan: false,
  });
  const { tabName, pageNo, listSize } = state;

  useLayoutEffect(() => {
    setState((previousValue: State) => ({
      ...previousValue,
      loading: true,
    }));
    fetchMembers("fetch");
  }, [seqPartner, seqPartnerBranch, seqPartnerCoach, tabName]);

  const fetchMembers = (type: string) => {
    setState((previousValue: State) => ({
      ...previousValue,
      loading: true,
    }));
    const data: any = serializeObject({ element: form.current });
    callApi(
      "/members",
      {
        seqPartner: seqPartner,
        seqPartnerBranch: seqPartnerBranch,
        seqPartnerCoach: seqPartnerCoach,
        memberListType: tabName,
        keyword: data.name,
        pageNo: pageNo,
        rowAmt: listSize,
      },
      "GET"
    )
      .then((res) => {
        if (type === "add") {
          setMembers((previousValue: Members) => ({
            ...previousValue,
            memberList: previousValue.memberList.concat(res.memberList),
          }));
        } else {
          setMembers(res);
        }
        if (res.memberList.length < listSize) {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: 0,
            isDone: true,
            isScrollEnd: true,
          }));
        } else {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: previousValue.pageNo + previousValue.listSize,
            isDone: false,
          }));
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setState((previousValue: State) => ({
          ...previousValue,
          loading: false,
        }));
      });
  };

  const getMemberListText = () => {
    let memberText;
    if (Object.keys(chooseMemberList).length === 1) {
      memberText = chooseMemberList[Object.keys(chooseMemberList)[0]].name + "님";
    } else if (Object.keys(chooseMemberList).length === 2) {
      memberText =
        chooseMemberList[Object.keys(chooseMemberList)[0]].name +
        "님, " +
        chooseMemberList[Object.keys(chooseMemberList)[1]].name +
        "님";
    } else if (Object.keys(chooseMemberList).length > 2) {
      memberText =
        chooseMemberList[Object.keys(chooseMemberList)[0]].name +
        "님 외 " +
        (Object.keys(chooseMemberList).length - 1) +
        "명";
    }
    return memberText;
  };

  const handleClickTab = (tabName: "APPOINTMENT" | "CHARGE" | "ENTRANCE") => {
    setMembers((previousValue: Members) => ({
      ...previousValue,
      memberList: [],
    }));
    setState((previousValue: State) => ({
      ...previousValue,
      tabName,
      pageNo: 0,
      isDone: false,
      isScrollEnd: false,
    }));
  };

  const handleClickMember = (d: any) => {
    if (!chooseMemberList[d.seqMember]) {
      setMember((previousValue: any) => {
        const seqMember = d.seqMember;
        return { ...previousValue, [seqMember]: d };
      });
    } else {
      setMember((previousValue: any) => {
        const updateMemberList = previousValue;
        delete updateMemberList[d.seqMember];
        return { ...updateMemberList };
      });
    }
  };

  return (
    <div className="picker-body choose-schedule-pop">
      <div className="member-mngt-wrap" ref={form}>
        <MemberSearchPop
          from="community"
          onClickMember={handleClickMember}
          chooseMemberList={chooseMemberList}
        />
        <Condition
          tabName={tabName}
          appointmentMemberTotalCount={members.appointmentMemberTotalCount}
          chargeMemberTotalCount={members.chargeMemberTotalCount}
          entranceMemberTotalCount={members.entranceMemberTotalCount}
          onClickTab={handleClickTab}
        />
        <MemberList
          memberList={members.memberList}
          scrollEnd={state.isScrollEnd}
          loading={state.loading}
          listSize={state.listSize}
          isDone={state.isDone}
          isBan={state.isBan}
          fetchMembers={fetchMembers}
          from="community"
          onClickMember={handleClickMember}
          chooseMemberList={chooseMemberList}
        />
      </div>
      <div
        className={"add-comunity-member-btn" + (isEmpty(chooseMemberList) ? "" : " active")}
        onClick={() => handleClose()}
      >
        {isEmpty(chooseMemberList) ? "선택" : getMemberListText()}
      </div>
    </div>
  );
};

export default memo(ChooseMemberPassPopWrap);
